<template>
  <div class="youtaofang">
    <topTitle title="柏庭荟" :list="list" :newData="newData"></topTitle>
    <p class="top_p">
      柏庭荟秉承柏庭养老“天赋使命，以仁慈之心关爱众人；传承德孝信念，以利他之心服务老人”的企业理念，专注于改善中国长者生活，倡导乐享理念，主张健康、自由、爱好、社交的生活方式。柏庭荟对会员给予深切的人文关怀，以俱乐部形式搭建会员间健康生活、自由发展、兴趣爱好与社会交往的平台，实现会员退休生活品质的提升，让退休生活成为人生中最美好的时光，并通过传播真、善、美的理念，推动老龄化社会文明的进步。
    </p>
    <div class="item_bd">
      <video
        id="myVideo"
        style="width: 100%;"
        controls
        preload="auto"
        poster="http://img.bj.wezhan.cn/content/sitefiles/2024951/images/11352657_11.jpeg"
        src="https://wap.xbcare.com.cn/static/video/promotional-video.f20.mp4"
      ></video>
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
         {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
         {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
         {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
         {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        }
      ],
      newData: 0,
      list2: [
        {
          img: require("../../assets/image/fuwu/fang_1.png"),
        },
        {
          img: require("../../assets/image/fuwu/fang_2.png"),
        },
        {
          img: require("../../assets/image/fuwu/fang_3.png"),
        },
      ],
     
    };
  },
  methods: {},
  mounted: function () {
  
  },
  components: {
    topTitle,
  },
  props: {
   
  },
};
</script>
<style scoped="scoped">
.youtaofang {
  width: 100%;
  height: 100%;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  width: 100%;
  margin-top: 0.5625rem;
  padding: 0 0.3rem;
}

</style>